import {IChatMessage, IChatMessageBot, IChatMessageBotEmbed, IChatMessageUser} from "@listat/r2-core";
import r2Core from "@core/r2";
import {
    IChatRepositoryMessage,
    IChatRepositoryMessageBot, IChatRepositoryMessageUser
} from "@core/office/office-chat-repository/office-chat-repository.types";

export class ChatUtilsService {
    constructor() {
    }

    public isSenderBot(message: IChatMessage): message is IChatMessageBot {
        return message?.sender === r2Core.constants.chat.MESSAGE_SENDER.bot
    }

    public isSenderUser(message: IChatMessage): message is IChatMessageUser {
        return message.sender === r2Core.constants.chat.MESSAGE_SENDER.user
    }

    public isSenderRepositoryBot(message: IChatRepositoryMessage): message is IChatRepositoryMessageBot {
        return message?.sender === r2Core.constants.chat.MESSAGE_SENDER.bot
    }

    public isSenderRepositoryUser(message: IChatRepositoryMessage): message is IChatRepositoryMessageUser {
        return message.sender === r2Core.constants.chat.MESSAGE_SENDER.user
    }

    public isValueImg(message: IChatMessageBot): boolean {
        const options = message?.options;
        const embeds = message?.options?.embeds;
        return !!(options && embeds && embeds.length && this.firstEmbeds(message).image);
    }

    public firstEmbeds(message: IChatMessageBot): IChatMessageBotEmbed {
        const embed = message.options.embeds[0];
        if (!embed) {
            throw new Error('First embed not found');
        }

        return embed
    }

}
